import script from "./ToggleEditMode.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleEditMode.vue?vue&type=script&lang=ts&setup=true"

import "./ToggleEditMode.vue?vue&type=style&index=0&id=b7b55e3c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b55e3c"]])

export default __exports__